import { ReactNode } from 'react';
import { css } from '@emotion/css';
import { Box } from '@spark-web/box';
import { CheckCircleIcon, XCircleIcon } from '@spark-web/icon';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { useTheme } from '@spark-web/theme';

type DocumentExampleCardProps = {
  variant: 'upload' | 'avoid';
  title: string;
  image: string;
  imageAlt: string;
  children: ReactNode;
};

function DocumentExampleCard({ variant, title, image, imageAlt, children }: DocumentExampleCardProps) {
  const isUpload = variant === 'upload';
  const theme = useTheme();
  return (
    <Box
      flex={1}
      minWidth={0}
      background="surface"
      borderRadius="medium"
      borderWidth="standard"
      border={isUpload ? 'primary' : 'critical'}
      padding="medium"
    >
      <Stack gap="small">
        <Box display="flex" alignItems="center" gap="xsmall">
          {isUpload ? <CheckCircleIcon tone="positive" size="xsmall" /> : <XCircleIcon tone="critical" size="xsmall" />}
          <Text size="large" weight="semibold" tone={isUpload ? 'positive' : 'critical'}>
            {title}
          </Text>
        </Box>
        <Text size="small">{children}</Text>
        {/* Image renders directly (no tinted padded wrapper, no maxWidth cap) so it fills the
            card width — the colored border, icon and title still convey the this/not-this cue. */}
        <img
          src={image}
          alt={imageAlt}
          className={css({ width: '100%', height: 'auto', display: 'block', borderRadius: theme.border.radius.small })}
        />
      </Stack>
    </Box>
  );
}

export default DocumentExampleCard;
